module.exports = __webpack_public_path__ + "img/dev.4ce2baf4.jpeg";